import * as PIXI from "pixi.js";
window.PIXI = PIXI;
export default PIXI